module.exports = __webpack_public_path__ + "img/aixin.38aac197.png";